export default "__VITE_ASSET__Cea996VH__"